export interface Web3ButtonProps {
  Web3ButtonView: any;
  Web3ButtonViewProps?: any;
  title: string;
  prefix?: JSX.Element;
  disable?: boolean;
  preAction: () => void;
  postAction?: (txHash: string) => void;
  preActionResponse?: any;
  postActionResponse?: any;
}

export interface DEFAULT_WEB_3_BUTTON_STATE {
  isRequestInitiated: boolean;
  isTransactionFailed: boolean;
  isTransactionProcessing: boolean;
  isTransactionSuccessful: boolean;
  transactionType: string;
  transactionId: string;
}

export interface DEFAULT_WEB_3_BUTTON_ACTIONS {
  initiatingRequest: (type: string) => void;
  processingRequest: (txId: string) => void;
  requestSuccessful: () => void;
  requestFailed: () => void;
  resetWeb3ButtonState: () => void;
}

export const defaultWeb3ButtonState: DEFAULT_WEB_3_BUTTON_STATE = {
  isRequestInitiated: false,
  isTransactionFailed: false,
  isTransactionProcessing: false,
  isTransactionSuccessful: false,
  transactionType: "",
  transactionId: "",
};
